// extracted by mini-css-extract-plugin
module.exports = {"action":"TimeLine_action_3loVj","slider":"TimeLine_slider_2BltL"};